import { DatePicker } from "@etframework/ui.components";
import { forwardRef, useImperativeHandle, useRef } from "react";
import { PropertyRow } from "../PropertyUpdateRowInput";
import { useTranslation } from "react-i18next";

export const DateUpdateInput = forwardRef(
  ({ change, field, settings, onRemove, value = null, id }, ref) => {
    const { i18n } = useTranslation(["BulkUpdateTasksModal", "Shared"], {
      useSuspense: false,
    });

    const compRef = useRef(null);

    useImperativeHandle(ref, () => ({
      applyValue: (properties) => {
        const value = compRef.current.getValue();
        if (value) properties[field] = value;
      },
      getValue: () => ({
        field: field,
        value: compRef.current?.getValue(),
        hasValue: !!compRef.current?.getValue(),
        settings: settings,
      }),
      focus: () => compRef.current?.getComponentRef()?.focusIn(),
    }));

    return (
      <PropertyRow
        key={field}
        field={field}
        label={settings?.headerText}
        onRemove={onRemove}
        settings={settings}
      >
        <DatePicker
          ref={compRef}
          className={"w-15"}
          id={id}
          value={value}
          change={change}
          language={i18n.language}
        />
      </PropertyRow>
    );
  }
);
